import {get,post} from '../../../util/api'
import * as type from './type'
import * as selector from './selector'
import {selectCustomerId} from "../../customer/state/detail/selector";
import * as taskDetailSelector from "../../process/state/task-detail/selector";
import {convertToCents} from "../../../util/money";

export const getPartialRefundRequest = () => ({
    type: type.GET_PARTIAL_REFUND_DATA_REQUEST,
})

export const getPartialRefundSuccess = (partialRefundData) => {

    return ({
        type: type.GET_PARTIAL_REFUND_DATA_SUCCESS,
        payload: {
            partialRefundData,
        },
    });
};

export const getPartialRefundError = (error) => ({
    type: type.GET_PARTIAL_REFUND_DATA_ERROR,
    payload: {
        error,
    },
});

export const savePartialRefundRequest = () => ({
    type: type.SAVE_PARTIAL_REFUND_DATA_REQUEST,
});

export const savePartialRefundSuccess = (refund) => ({
    type: type.SAVE_PARTIAL_REFUND_DATA_SUCCESS,
    payload: {
        refund,
    },
});

export const savePartialRefundError = (error) => ({
    type: type.SAVE_PARTIAL_REFUND_DATA_ERROR,
    payload: {
        error,
    },
})

export const getRefundableSalesOrderListRequest = () => ({
    type: type.GET_REFUNDABLE_SALES_ORDER_LIST_REQUEST,
})

export const getRefundableSalesOrderListSuccess = (salesOrderList) => {

    return ({
        type: type.GET_REFUNDABLE_SALES_ORDER_LIST_SUCCESS,
        payload: {
            salesOrderList,
        },
    });
};

export const getRefundableSalesOrderListError = (error) => ({
    type: type.GET_REFUNDABLE_SALES_ORDER_LIST_ERROR,
    payload: {
        error,
    },
});

export const addValidationMessage = (message) => ({
    type: type.ADD_VALIDATION_MESSAGE,
    payload: {
        message,
    },
});

export const clearValidationMessageList = () => ({
    type: type.CLEAR_VALIDATION_MESSAGE_LIST,
});

export const savePartialRefundData = () => (dispatch, getState) => {
    const state = getState();
    const params = selector.selectOwnState(state).partialRefundData;

    let hasErrors = false;

    dispatch(clearValidationMessageList())
    //validation
    if (params.salesOrderId === '' || params.amount === '' || params.reason === '') {
        dispatch(addValidationMessage({
            messageId: 1,
            message: 'All fields are required.'
        }))

        hasErrors = true;
    }

    const salesOrderList = selector.selectSalesOrderPartialRefundList(state);
    const selectedSalesOrder = salesOrderList.find(salesOrder => salesOrder.id === params.salesOrderId);
    const salesOrderBrutPriceEur = (selectedSalesOrder.brutPrice / 100).toFixed(2);
    const amountInCents = convertToCents(params.amount);

    if (selectedSalesOrder && amountInCents > selectedSalesOrder.brutPrice) {
        dispatch(addValidationMessage({
            messageId: 2,
            message: 'Correction Invoice Amount cannot be greater than the Sales Order brut price: ' + salesOrderBrutPriceEur
        }))

        hasErrors = true;
    } else if (selectedSalesOrder && amountInCents < 0.01) {
        dispatch(addValidationMessage({
            messageId: 2,
            message: 'Correction Invoice Amount cannot be less than 0.01'
        }))

        hasErrors = true;
    }

    if (hasErrors) {
        return;
    }

    dispatch(savePartialRefundRequest());
    const processInstanceId = taskDetailSelector.selectProcessInstanceId(state);

    post('/api/partial-refund/save', {
        ...params,
        amount: amountInCents,
        processInstanceId: processInstanceId,
    })
        .then((refund) => {
            dispatch(savePartialRefundSuccess(refund));
        })
        .catch(error => {
            dispatch(savePartialRefundError(error));
        });
}

export const getPartialRefundData = () => (dispatch, getState) => {

    const processInstanceId = taskDetailSelector.selectProcessInstanceId(getState());

    dispatch(getPartialRefundRequest());
    return get('/api/partial-refund/find-by-process-instance-id?processInstanceId=' + processInstanceId)
        .then((partialRefundData) => {
            dispatch(getPartialRefundSuccess({
                ...partialRefundData,
                amount: partialRefundData.amount.toFixed(2) / 100,
            }));
        })
        .catch(error => {
            dispatch(getPartialRefundError(error));
        });
}

export const getRefundableSalesOrderList = () => (dispatch, getState) => {
    const customerId = selectCustomerId(getState());

    dispatch(getRefundableSalesOrderListRequest());
    return get('/api/partial-refund/find-refundable-by-customer-id?customerId=' + customerId)
        .then((salesOrderList) => {
            dispatch(getRefundableSalesOrderListSuccess(salesOrderList));
        })
        .catch(error => {
            dispatch(getRefundableSalesOrderListError(error));
        });
}

export const changePartialRefundData = (name, value) => ({
    type: type.CHANGE_PARTIAL_REFUND_DATA,
    payload: {
        name,
        value,
    },
})



// WEBPACK FOOTER //
// ./src/modules/partial-refund/state/action.js